import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type SnackbarType = "success" | "error" | "info" | "warning";

interface SnackbarState {
    open: boolean;
    message: string;
    type: SnackbarType;
}

const initialState: SnackbarState = {
    open: false,
    message: "",
    type: "success",
};

const snackbarSlice = createSlice({
    name: "snackbar",
    initialState,
    reducers: {
        showSnackbar: (
            state,
            action: PayloadAction<{ message: string; type: SnackbarType }>
        ) => {
            state.open = true;
            state.message = action.payload.message;
            state.type = action.payload.type;
        },
        hideSnackbar: (state) => {
            state.open = false;
        },
    },
});

export const { showSnackbar, hideSnackbar } = snackbarSlice.actions;
export default snackbarSlice.reducer;
